import { constantes_default } from "../common/traducao";
import http from "../config/axiosConfig/http-common";
import { SetTextosIdioma } from "../config/localstorageConfig/localstorage";
import ServiceBase from "./service.base";


class IdiomasVendaService extends ServiceBase {

    getAll() {
        return http.post("/Idiomas");
    }

    getTraducoes(listachaves) {
        const idiomaenvio = listachaves; // this.getIdiomaEnvio(idioma, listachaves);
        return http.post("/Idiomas", idiomaenvio);

    }

    async setCache(idioma) {
        try {
            const _idioma = JSON.parse(JSON.stringify(constantes_default));
            _idioma.$IdiomaDestino = idioma;

            const response = await http.post("/Idiomas", _idioma);
            SetTextosIdioma(idioma, response.data);
        } catch (e) {
            console.error(`Erro ao carregar idioma ${idioma}:`, e);
            throw e;
        }
    }
}

export default new IdiomasVendaService();